import { useEffect, useState } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import { api } from "../lib/api";

let cfgPromise = null;
const getCfg = () => {
  if (!cfgPromise) cfgPromise = api.get("/public/recaptcha").then((r) => r.data).catch(() => ({ enabled: false, site_key: "" }));
  return cfgPromise;
};

export default function CaptchaField({ onToken, captchaRef }) {
  const [cfg, setCfg] = useState(null);

  useEffect(() => { getCfg().then(setCfg); }, []);
  useEffect(() => {
    if (cfg && (!cfg.enabled || !cfg.site_key)) onToken("disabled");
  }, [cfg]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!cfg || !cfg.enabled || !cfg.site_key) return null;
  return (
    <div data-testid="recaptcha-field">
      <ReCAPTCHA
        ref={captchaRef}
        sitekey={cfg.site_key}
        onChange={(token) => onToken(token || "")}
        onExpired={() => onToken("")}
        onErrored={() => onToken("")}
      />
    </div>
  );
}
